import React from 'react';
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Footprint,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import {rose} from '/theme/color/secondary.color';

import TabNavigationHeader from '../TabNavigationHeader';

const storyStyle = StyleSheet.create({
  footprint: {
    width: '100%',
  },
  content: {
    width: '100%',
    height: 200,
    alignItems: 'center',
    justifyContent: 'center',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: rose,
  },
});

storiesOf('layout', module).add('TabNavigationHeader', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView expand={true}>
        <Heading level={1}>Tab Navigation Header</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>TabNavigationHeader</Code> component is used to render a
          navigation header with icons.
        </Text>
        <Spacer size={16} />
        <Text>
          The space above the icons is reserved for the device's status bar. The
          actual amount of whitespace will be different between different device
          screen geometries.
        </Text>
        <Spacer size={16} />
        <Footprint style={storyStyle.footprint}>
          <TabNavigationHeader />
        </Footprint>
        <Spacer size={16} />
        <Heading level={2}>Content Wrapper</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>TabNavigationHeader</Code> wrapper component is a wrapper
          component around some contents.
        </Text>
        <Spacer size={16} />
        <Footprint style={storyStyle.footprint}>
          <TabNavigationHeader>
            <View style={storyStyle.content}>
              <Text>Content</Text>
            </View>
          </TabNavigationHeader>
        </Footprint>
        <Spacer size={6} />
        <Code>{'<TabNavigationHeader>'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'</TabNavigationHeader>'}</Code>
        <Spacer size={16} />
        <Heading level={2}>Event Handler</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>TabNavigationHeader</Code> component accepts a{' '}
          <Code>onIconPress</Code> prop to be used as event handler when an icon
          is clicked.
        </Text>
        <Spacer size={6} />
        <Code>{'<TabNavigationHeader'}</Code>
        <Code>{'  onIconPress={(iconName) => {...}}>'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'</TabNavigationHeader>'}</Code>
        <Spacer size={16} />
      </FlexView>
    </Spacing>
  </ScrollView>
));
